/*
 * Copyright (c) 2020  Apricad LLC. All Rights Reserved.
 */

import { Reducer, AnyAction } from "redux";

export type SecState = {
  readonly csrf?: string;
};

const secReducerDefaultState: SecState = {
  csrf: undefined,
};

export const secReducer: Reducer<any, AnyAction> = (
  state = secReducerDefaultState,
  action: AnyAction,
) => {
  return state;
};
